import ListIcon from "@redotech/redo-icons/list.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const PickSessionIdFilter: ArrayStringTableFilter<string> = {
  type: AdvancedFilterType.ARRAY_TO_STRING,
  itemLabel: "Session ID",
  operators: [
    ArrayStringFilterOperator.ANY_OF,
    ArrayStringFilterOperator.NONE_OF,
  ],
  data: {
    name: "pickSessionIdValue",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: ListIcon,
  displayName: "Pick session (ID)",
  dbSearch: true,
};
